import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { runtimeConfig } from '../utils';

let supabaseClient: SupabaseClient | null = null;

export function getSupabaseClient(): SupabaseClient {
  if (supabaseClient) {
    return supabaseClient;
  }
  const SUPABASE_PROJECT_ID = runtimeConfig.VITE_SUPABASE_PROJECT_ID;
  const SUPABASE_PROJECT_URL = runtimeConfig.VITE_SUPABASE_PROJECT_URL;
  const SUPABASE_PUBLISHABLE_KEY = runtimeConfig.VITE_SUPABASE_PUBLISHABLE_KEY;

  if (!SUPABASE_PROJECT_URL && !SUPABASE_PROJECT_ID) {
    throw new Error('Missing VITE_SUPABASE_PROJECT_URL or VITE_SUPABASE_PROJECT_ID environment variables');
  }

  if (!SUPABASE_PUBLISHABLE_KEY) {
    throw new Error('Missing VITE_SUPABASE_PUBLISHABLE_KEY environment variable');
  }

  const supabaseUrl = SUPABASE_PROJECT_URL || `https://${SUPABASE_PROJECT_ID}.supabase.co`;

  supabaseClient = createClient(supabaseUrl, SUPABASE_PUBLISHABLE_KEY, {
    auth: {
      storageKey: 'auth',
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  });

  return supabaseClient;
}

export function resetSupabaseClient(): void {
  supabaseClient = null;
}
